<div class="success-dialog-wrapper">
    <!-- Close Button -->
    <button class="btn-close-dialog" (click)="close()">
        <i class="bi bi-x"></i>
    </button>

    <!-- Header with Confetti & Icon -->
    <div class="success-header">
        @if(data.icon ==='success'){
        <div class="confetti-layer">
            <div class="confetti-item c1"></div>
            <div class="confetti-item c2"><i class="bi bi-star-fill"></i></div>
            <div class="confetti-item c3"></div>
            <div class="confetti-item c4"></div>
            <div class="confetti-item c5"></div>
            <div class="confetti-item c6"></div>
            <div class="confetti-item c7"><i class="bi bi-star-fill"></i></div>
            <div class="confetti-item c8"></div>
            <div class="confetti-item c9"><i class="bi bi-star-fill"></i></div>
            <div class="confetti-item c10"><i class="bi bi-star-fill"></i></div>
            <div class="confetti-item c11"></div>
            <div class="confetti-item c12"><i class="bi bi-star-fill"></i></div>
        </div>
    }
    @if(data.icon === 'success'){
    <div class="icon-outer-circle">
        <div class="icon-inner-circle">
            <i class="bi bi-check" style="-webkit-text-stroke: 1px;border: none;" (click)="close()"></i>
        </div>
    </div>
    } @else if(data.icon === 'error'){
    <div class="icon-outer-error-circle">
        <div class="icon-inner-error-circle">
            <i class="bi bi-exclamation" style="-webkit-text-stroke: 1px;border: none;" (click)="close()"></i>
        </div>
    </div>
    }
    </div>

    <!-- Body -->
    <div class="dialog-body">
        <h2 class="dialog-title">{{ data.title || 'Success!' }}</h2>
        <p class="dialog-subtitle">{{ data.subtitle }}</p>
    </div>

    <!-- Action -->
    <div class="dialog-action mt-4">
         <button class="btn btn-continue w-100 mb-3" *ngIf="data.pageReference === 'update-seller-catalog'" (click)="addAnotherBrand()">Add another brand</button>
        <button class="btn btn-continue w-100" (click)="close()">Continue</button>
    </div>
</div>